import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

import { XLarge } from '../../components/icons';
import withDeviceType from '../../hoc/with-device-type';
import withCardBackgroundColor from '../../hoc/with-card-background-color';
import withTranslate from '../../hoc/with-translate';
import styles from './modal.scss';
import { handleEnterKeyUp, handleEscapeKeyUp, handleTabKeyUp } from '../../services/accessibility';
import AccessibilityListener from '../accessibility-listener';

export class Modal extends Component {
  setInitialFocusElement = ref => {
    this.initialFocusElement = ref;
  };

  focusInitialElement = () => {
    this.initialFocusElement && this.initialFocusElement.focus();
  };

  renderCloseButtonDesktop = () => {
    const { t, onClose } = this.props;
    if (!onClose) {
      return null;
    }

    return (
      <button
        className={classNames(styles.closeIcon, 'modal__close')}
        onClick={this.handleClose}
        onKeyUp={handleEnterKeyUp(this.handleClose)}
        aria-label={t('modal.close')}
      >
        <XLarge/>
      </button>
    );
  };

  // call onClose() without arguments for modal
  handleClose = () => this.props.onClose && this.props.onClose();

  componentDidMount() {
    this.focusInitialElement();
  }

  render() {
    const { className, children, isDesktop, backdrop, cardBackgroundColor } = this.props;
    const containerClassName = classNames(styles.container, { [styles.withShadow]: !backdrop });
    const style = { backgroundColor: cardBackgroundColor };

    return (
      <main
        ref={this.setInitialFocusElement}
        className={containerClassName}
        onKeyUp={handleEscapeKeyUp(this.handleClose)}
        tabIndex="0"
      >
        <AccessibilityListener/>
        {backdrop ?
          <div
            className={classNames(styles.backdrop, 'modal__overlay')}
            onClick={this.handleClose}
            onKeyUp={handleEnterKeyUp(this.handleClose)}
          /> :
          null}
        {isDesktop ? this.renderCloseButtonDesktop(this.handleClose) : null}
        <div className={classNames(styles.modal, className, 'default-forum-card-background-color')} style={style}>
          {children}
        </div>
        <div className={styles.focusWrapper} tabIndex="0" onKeyUp={handleTabKeyUp(this.focusInitialElement)}/>
      </main>
    );
  }
}

Modal.propTypes = {
  className: PropTypes.string,
  cardBackgroundColor: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  isDesktop: PropTypes.bool,
  backdrop: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

Modal.defaultProps = {
  backdrop: true,
};

// prettier-ignore
export default flowRight(
  withCardBackgroundColor,
  withDeviceType,
  withTranslate
)(Modal);



// WEBPACK FOOTER //
// ./app/components/modal/modal.js